import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MaintenancePage from 'pages/MaintenancePage'
import { fromAuth } from 'store/selectors'

const MaintenanceWrapper = ({ appOperational, children }) =>
  appOperational ? children : <MaintenancePage />

MaintenanceWrapper.propTypes = {
  children: PropTypes.any,
  appOperational: PropTypes.bool,
}

export default connect(state => ({
  appOperational: fromAuth.isAppOperational(state),
}))(MaintenanceWrapper)
